import { toRefs, ref, watch } from 'vue';
import CarouselItemImg from './component-lib.esm5.js';
import CircularLoader from '../../components/circular-loader/component-lib.esm.js';
import { appendUTMParams } from '../../utils/component-lib.esm2.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { EVENTS } from '../../config/component-lib.esm.js';
import { isClient } from '../../utils/component-lib.esm5.js';

//
var script = {
  components: {
    CarouselItemImg,
    CircularLoader
  },
  data() {
    return {
      hasLoaded: false,
      canLoadImages: false
    };
  },
  props: {
    id: {
      type: String,
      default: null
    },
    banner: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    index: Number,
    currentIndex: Number,
    isShown: Boolean,
    enableUtmParameters: {
      type: Boolean,
      default: false
    },
    utmMedium: String,
    utmSource: String,
    link: {
      type: Object,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      index,
      isShown,
      banner
    } = toRefs(props);
    const root = ref(null);
    const theme = useTheme();
    watch(isShown, newValue => {
      if (newValue) {
        emit('event', {
          name: EVENTS.CAROUSEL_SWIPE,
          banner_id: banner.value._id.$oid,
          position: index.value + 1
        });
      }
    });
    return {
      root,
      loaderColor: theme.value.colors.gray500
    };
  },
  computed: {
    media() {
      return this.banner.media_item;
    },
    hasUrl() {
      return this.banner.url;
    },
    bannerUrl() {
      if (this.enableUtmParameters) {
        const utmMedium = this.utmMedium;
        const utmSource = this.utmSource;
        return appendUTMParams(this.banner.url, utmMedium, utmSource, this.banner.image_alt);
      } else return this.banner.url;
    },
    classes() {
      return {
        'site-carousel__item': true,
        // 'site-carousel__item--no-trans': true,
        'site-carousel__item--muted': Math.abs(this.currentIndex - this.index) === 1,
        'site-carousel__item--hidden': Math.abs(this.currentIndex - this.index) > 1,
        loaded: this.hasLoaded
      };
    },
    styles() {
      return {
        width: `${this.width}%`
      };
    }
  },
  watch: {
    currentIndex() {
      this.checkImageLoad();
    }
  },
  mounted() {
    this.checkImageLoad();

    // check if image has already loaded
    if (isClient) {
      const img = this.$refs.image.$el;
      if (img && img.loaded) this.hasLoaded = true;
    }
  },
  methods: {
    checkImageLoad() {
      if (Math.abs(this.currentIndex - this.index) <= 1) {
        this.canLoadImages = true;
      }
    },
    imageLoaded() {
      this.hasLoaded = true;
      this.$emit('image-loaded');
    }
  }
};
export { script as default };